export type VenueCategory = 'bar' | 'restaurant' | 'cafe' | 'coffee' | 'club' | 'other';

export const VENUE_CATEGORY_OPTIONS: Array<{ value: VenueCategory; label: string }> = [
  { value: 'bar', label: 'Бар' },
  { value: 'restaurant', label: 'Ресторан' },
  { value: 'cafe', label: 'Кафе' },
  { value: 'coffee', label: 'Кофейня' },
  { value: 'club', label: 'Клуб' },
  { value: 'other', label: 'Другое' },
];

export const VENUE_CATEGORY_ORDER = VENUE_CATEGORY_OPTIONS.map((option) => option.value);

export function isVenueCategory(value: string): value is VenueCategory {
  return VENUE_CATEGORY_ORDER.includes(value as VenueCategory);
}
